import classNames from 'classnames';
import React from 'react';
import { IconCloseV2 } from '../Icons';

const MultiPlacesTag = (props) => {
  return (
    <button
      type='button'
      className={classNames(props?.classNames?.selectedTag, {
        'react-tags__selected-tag--highlighted': props?.isHighlighted,
      })}
      onClick={null}
    >
      <div className='button-content'>
        <div className='address-wrap' onClick={props?.onClick}>
          <div className={props?.classNames?.selectedTagName}>
            <div className='icon'>{props?.tagIcon}</div>
            <div className='location-name'>
              <span className='me-2'>{props?.totolIds}</span>
              {props.flachenLabel}
            </div>
          </div>
        </div>

        <div onClick={props.onDelete} className='tag-close-icon'>
          <IconCloseV2 />
        </div>
      </div>
    </button>
  );
};

export default MultiPlacesTag;
